<h1>Contact Tab</h1>
<button (click)="checkAuth()">
  New Bot
</button>
